import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=80283a1a&scoped=true"
import script from "./OrderRefund.vue?vue&type=script&lang=js"
export * from "./OrderRefund.vue?vue&type=script&lang=js"
import style0 from "./OrderRefund.vue?vue&type=style&index=0&id=80283a1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80283a1a",
  null
  
)

export default component.exports